export default __webpack_public_path__ + "static/media/notification.451ed525.mp3";